import React from 'react';

/**
 *  Like <select> but supports different color on placeholder-text (like other input elements has).  (See: https://stackoverflow.com/questions/13154274/onchange-event-of-select-box )
 *
 *  (Yes, the WHOLE purpose of this component, is to be able to show the <select> in a different color, when the placeholder-option is selected)
 *
 *  All it does is: if a "disabled" <option> element is selected, it adds an extra class to the <select> element.
 */
export default class Select extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isPlaceholderSelected: false
        };
    }

    componentDidMount() { // This method is called after the FIRST render
        this.checkPlaceholderSelected();
    }

    componentDidUpdate(prevProps, prevState) { // This method is called after the each render, EXCEPT the first.
        this.checkPlaceholderSelected();
    }
    
    checkPlaceholderSelected = () => {
        const selectElem = this.refs.select;

        if (selectElem.options.length == 0) // abort if no <option>-elements in the <select>
            return;

        if (selectElem.selectedIndex < 0 || selectElem.selectedIndex >= selectElem.options.length) // abort if selectedIndex is not within range (if it is -1 for example - can happen: https://developer.mozilla.org/en-US/docs/Web/API/HTMLSelectElement/selectedIndex)
            return;

        const isPlaceholderSelected = selectElem.options[selectElem.selectedIndex].disabled;
        if (isPlaceholderSelected != this.state.isPlaceholderSelected) {
            this.setState({isPlaceholderSelected:isPlaceholderSelected});
        }
    };


    render() {
        let className = this.props.className;

        if (this.state.isPlaceholderSelected) {
            className += " select-placeholder-selected"
        }

        const changedProps = Object.assign({}, this.props);
        changedProps.className = className;

        return (
            <div className="select-1">
                <select ref="select" {...changedProps}>
                    {this.props.children}
                </select>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/src/components/reusable/select/Select.js